import { useQuery } from 'react-query';
import {
	getDailyCollectionTrend,
	getMonthlyCollectionTrend,
	getCollectionsByPayorsAnalysis,
	getCollectionsByProductsAnalysis,
	getPayorsCollectionsTrendMonthly,
	type CollectionTrendParams,
} from '@/services/collection';

export const useGetMonthlyCollectionTrend = (
	params: CollectionTrendParams,
	enabled = true,
) => {
	return useQuery({
		queryKey: ['monthlyCollectionTrend', params],
		queryFn: () => getMonthlyCollectionTrend(params),
		enabled,
		keepPreviousData: true,
	});
};

export const useGetDailyCollectionTrend = (
	params: CollectionTrendParams,
	enabled = true,
) => {
	return useQuery({
		queryKey: ['dailyCollectionTrend', params],
		queryFn: () => getDailyCollectionTrend(params),
		enabled,
		keepPreviousData: true,
	});
};

export const useGetCollectionsByPayorsAnalysis = (
	params: CollectionTrendParams,
	enabled = true,
) => {
	return useQuery({
		queryKey: ['collectionsByPayorsAnalysis', params],
		queryFn: () => getCollectionsByPayorsAnalysis(params),
		enabled,
		keepPreviousData: true,
	});
};

export const useGetCollectionsByProductsAnalysis = (
	params: CollectionTrendParams,
	enabled = true,
) => {
	return useQuery({
		queryKey: ['collectionsByProductsAnalysis', params],
		queryFn: () => getCollectionsByProductsAnalysis(params),
		enabled,
		keepPreviousData: true,
	});
};

export const useGetPayorsCollectionsTrendMonthly = (
	params: CollectionTrendParams,
	enabled = true,
) => {
	return useQuery({
		queryKey: ['payorsCollectionsTrendMonthly', params],
		queryFn: () => getPayorsCollectionsTrendMonthly(params),
		enabled,
		keepPreviousData: true,
	});
};

